var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8bcca181f1ad37e1762c2b4ead37940647d81903"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["profitopia@profitopia"]={id:"8bcca181f1ad37e1762c2b4ead37940647d81903"};
      